import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { NavLink, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

export default function PaymentReportPaid() {    
    const navigate = useNavigate();
    const handleNavigateToPaymentReport = () => {
        navigate('/payment-report');
    }
    const handleNavigateToPaymentReportPaid = () => {
        navigate('/payment-report-paid');
    }
    const handleNavigateToPaymentReportUnpaid = () => {
        navigate('/payment-report-unpaid');
    }
    const handleNavigateToPaymentReportDaily = () => {
        navigate('/payment-report-daily');
    }
    // =========>> Constant
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentYear = currentDate.getFullYear();

    // ========================>> useState
    const [searchTerm, setSearchTerm] = useState('');
    const [dateSelectionView, setDateSelectionView] = useState({
        month: currentMonth,
        year: currentYear,
    });
    const [dateSelectionViewRecordLoading, setDateSelectionViewRecordLoading] = useState();
    
    const [listingDataLoading, setListingDataLoading] = useState(false); 
    const [listingData, setListingData] = useState([]);  

    // =================>> Handle input changes
    const handleDateSelectionViewInputChange = (e) => {
        const { name, value } = e.target;
        setDateSelectionView((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    let monthRender = [];
    for (let i = 1; i <=12; i++) {
        monthRender.push(i);
    }

    let yearRender = [];
    for (let i = currentYear; i >= 2024; i--) {
        yearRender.push(i);
    }
    // ==============================>> Fetch API
    const fetchSearch = async (searchTerm) => {
        const monthYear = dateSelectionView.month.toString() + dateSelectionView.year.toString();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/payment/paid?monthYear=${monthYear}&searchTerm=${searchTerm}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json'
                }
            });
    
            if (!response.ok) {
                throw new Error('Failed to fetch search');
            }
    
            const data = await response.json(); 
            setListingData(data); 
        } catch (error) {
            console.error('Error fetching search:', error);
        }
    };
    const handleSearchSubmit = (event) => {
        event.preventDefault(); 
        fetchSearch(searchTerm); 
    }

    const handleViewRecord = async (event) => {
        event.preventDefault();
        setListingDataLoading(true);
        setListingData([]);
        const monthYear = dateSelectionView.month.toString() + dateSelectionView.year.toString();

        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/payment/paid?monthYear=${monthYear}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to fetch data.');
            }

            const dataExpense = await response.json();
            setListingData(dataExpense);
        } catch (err) {
            console.error(err.message);
        } finally {
            setListingDataLoading(false);
        }
    }

    const fetchView = async (currentMonthYear) => {
        setListingDataLoading(true);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/payment/paid?monthYear=${currentMonthYear}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to fetch data.');
            }

            const dataExpense = await response.json();
            setListingData(dataExpense);
        } catch (err) {
            console.error(err.message);
        } finally {
            setListingDataLoading(false);
        }
    };

    useEffect(() => {
    }, [listingData]); 

    useEffect(() => {

        const currentMonthYear = currentMonth.toString() + currentYear.toString();
        setDateSelectionView({
            month: currentMonth,
            year: currentYear
        })
        fetchView(currentMonthYear);  
    }, []);
    
    return (
        <div className="w-full h-[100dvh] bg-white flex flex-col">
            {/* Header */}
            <div className="w-full h-[8dvh] bg-[#0077B6] flex  items-center">
                <div className="md:w-[8%] pl-3 md:pl-10 items-center flex text-customWhite">
                    <NavLink to='/'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-12 text-white">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18" />
                        </svg>
                    </NavLink>
                </div>
                <div className="w-[84%] flex justify-center">
                    <h2 className="text-2xl font-semibold text-customWhite">បញ្ជីបង់ប្រាក់</h2>
                </div>
            </div>

            {/* Body */}
            <div className="w-full">
                {/* Action buttons */}
                <div className="flex flex-col md:flex-row w-full items-center border-b pr-5">
                    <div className="grid grid-cols-4 w-full md:w-[40%] h-[9dvh] text-xl mr-8">
                        <button className="hover:bg-slate-200" onClick={handleNavigateToPaymentReport}>ទាំងអស់</button>
                        <button className="hover:bg-slate-200 border-b-2 border-primary2" onClick={handleNavigateToPaymentReportPaid}>បានបង់ប្រាក់</button>
                        <button className="hover:bg-slate-200" onClick={handleNavigateToPaymentReportUnpaid}>មិនទាន់បង់</button>
                        <button className="hover:bg-slate-200" onClick={handleNavigateToPaymentReportDaily}>បញ្ជីប្រចាំថ្ងៃ</button>
                    </div>
                    <form onSubmit={handleSearchSubmit} className="w-[100%] md:w-[50%] flex justify-center md:justify-stretch my-3 md:my-0">
                        <div className="search-box !w-[95%] md:!w-[85%] pt-5">
                            <FontAwesomeIcon icon={faSearch} className="search-icon" />
                            <input
                                type="text"
                                placeholder="Search"
                                className=""
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)} 
                            />
                        </div>
                    </form>
                    <div className="md:ml-auto w-[95%] md:w-[30%] flex mb-3 md:mb-0">
                        <form className="flex w-[100%] items-center" onSubmit={handleViewRecord}>
                            <FormControl
                            fullWidth
                            margin="dense"
                            sx={{
                                '& .MuiInputLabel-root': {
                                    fontFamily: 'Kantumruy Pro',
                                    fontSize: '16px'
                                },
                                '& .MuiSelect-select': {
                                    fontFamily: 'Kantumruy Pro',
                                    fontSize: '16px'
                                },
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '10px',
                                    boxShadow: '0 1px 2px 0 #D9D9D9, 0 1px 2px 0 #E0E0E0'
                                },
                                marginRight: '15px',
                            }}
                            >
                                <InputLabel>ខែ *</InputLabel>
                                <Select
                                    name="month"
                                    value={dateSelectionView.month || ""}
                                    onChange={handleDateSelectionViewInputChange}
                                    label="ខែ *"
                                >
                                    {
                                        monthRender.map((month, index) => {
                                            return (
                                                <MenuItem key={index} value={month} sx={{fontFamily: 'Kantumruy Pro'}}>
                                                    {month}
                                                </MenuItem>
                                            );
                                        })
                                    }
                                </Select>
                            </FormControl>
                            <FormControl
                            fullWidth
                            margin="dense"
                            sx={{
                                '& .MuiInputLabel-root': {
                                    fontFamily: 'Kantumruy Pro',
                                    fontSize: '16px'
                                },
                                '& .MuiSelect-select': {
                                    fontFamily: 'Kantumruy Pro',
                                    fontSize: '16px'
                                },
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '10px',
                                    boxShadow: '0 1px 2px 0 #D9D9D9, 0 1px 2px 0 #E0E0E0'
                                },
                                marginRight: '15px',
                            }}
                            >
                                <InputLabel>ឆ្នាំ *</InputLabel>
                                <Select
                                    name="year"
                                    value={dateSelectionView.year || ""}
                                    onChange={handleDateSelectionViewInputChange}
                                    label="ឆ្នាំ *"
                                >
                                    {
                                        yearRender.map((year, index) => {
                                            return (
                                                <MenuItem key={index} value={year} sx={{fontFamily: 'Kantumruy Pro'}}>
                                                    {year}
                                                </MenuItem>
                                            );
                                        })
                                    }
                                </Select>
                            </FormControl>
                                <button type="submit" className="h-14 bg-primary2 font-medium text-white px-6 ml-5 rounded-lg duration-200">
                                    {dateSelectionViewRecordLoading ? 'Loading...' : 'View'}
                                </button>
                        </form>
                    </div>
                </div>

                {/* Table */}
                {listingDataLoading ? (
                    <div className="text-center my-10">
                        <p>Loading data...</p>
                    </div>
                    ) : (
                        <div className="overflow-x-auto overflow-y-auto !h-[76vh]">
                            <table className="table-display w-[100%]">
                                <thead className="!bg-secondary3 border-2">
                                    <tr>
                                        <th className="text-zinc-800  text-xs md:text-sm lg:!text-base !py-4 ml-3">បន្ទប់</th>
                                        <th className="text-zinc-800  text-xs md:text-sm lg:!text-base !py-4">ឈ្មោះ</th>
                                        <th className=" text-zinc-800  text-xs md:text-sm lg:!text-base !py-4">លេខទូរស័ព្ទ</th>
                                        <th className=" text-zinc-800  text-xs md:text-sm lg:!text-base !py-4">តម្លៃបានបង់</th>
                                        <th className=" text-zinc-800 text-xs md:text-sm  lg:!text-base !py-4">កាលបរិច្ឆេទបង់ប្រាក់ចុងក្រោយ</th>
                                        <th className=" text-zinc-800 text-xs md:text-sm  lg:!text-base !py-4">វិធីបង់ប្រាក់</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listingData ? (
                                        
                                        listingData.map((listing, index) => (
                                            <tr key={index} className="even:bg-gray-100 hover:bg-gray-200">
                                                <td className=" text-xs md:text-sm lg:!text-base !py-4 ml-3">{listing.room_number || 'N/A'}</td>
                                                <td className="font-medium text-xs md:text-sm lg:!text-base !py-4">{listing.tenant || '--'}</td>
                                                <td className="font-medium text-gray-600 text-xs md:text-sm lg:!text-base !py-4">
                                                    {listing.tenant_phone_number 
                                                        ? listing.tenant_phone_number.replace(/(\d{3})(\d{3})(\d{3,4})/, '$1 $2 $3') 
                                                        : '--'}
                                                </td>
                                                <td className="font-medium text-xs md:text-sm lg:!text-base !py-4">
                                                    {listing.payments.map((data, index) => (
                                                        <p key={index}>
                                                            {data.amount !== undefined && listing.amount !== null 
                                                            ? Number(data.amount).toLocaleString('en-US')
                                                            : '--'}{data.currency === 'USD' ? '$' : '៛'}
                                                        </p>
                                                    ))}
                                                </td>
                                                <td className="font-medium text-xs md:text-sm lg:!text-base !py-4">
                                                {listing.payments.map((data, index) => (
                                                    <p key={index}>
                                                        {data.created_at 
                                                            ? (() => {
                                                                const date = new Date(data.created_at);
                                                                const hours = date.getHours();
                                                                const minutes = date.getMinutes().toString().padStart(2, '0');
                                                                const ampm = hours >= 12 ? 'PM' : 'AM';
                                                                const formattedTime = `${hours % 12 || 12}:${minutes} ${ampm}`;
                                                                const day = date.getDate().toString().padStart(2, '0');
                                                                const month = (date.getMonth() + 1).toString().padStart(2, '0'); 
                                                                const year = date.getFullYear();
                                                                return `${formattedTime} ${day}-${month}-${year}`;
                                                            })() 
                                                            : '--'}
                                                    </p>
                                                ))}
                                                </td>
                                                <td className="font-medium text-xs md:text-sm lg:!text-base !py-4">
                                                    <div className="space-y-3">
                                                        {[
                                                            ...new Set(
                                                                listing.payments.map(
                                                                    (payment) => payment.payment_method?.method_name
                                                                )
                                                            ),
                                                        ].map((method, index) => (
                                                            <div key={index}>
                                                                <div
                                                                    className={`active-status-chip ${
                                                                        method === 'cash'
                                                                            ? 'text-green-900 !bg-green-200'
                                                                            : 'text-yellow-900 !bg-yellow-200'
                                                                    }`}
                                                                >
                                                                    {method}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="7">No records found for the selected month and year.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                            <div className="fixed bottom-0 left-0 right-0 bg-gray-100 shadow-md border-t border-gray-300 flex">
                                <div></div>
                                <div className="flex-2 px-4 py-4 text-center ml-auto mr-5 text-lg">
                                    សរុប ៖ <span className="font-bold">{listingData.length}</span> បន្ទប់
                                </div>
                                <div>
                                </div>
                            </div>
                        </div>
                        
                    )
                }         
            </div>
        </div>
    )
}